import React, { Component } from 'react';
import { Chart } from "react-google-charts";
class ResultTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    onTabClick = (groupName) => {
        this.setState({
            tab: groupName
        })
    }
    addTabs = (data) => {
        let tabs = []
        if (data.length > 0) {
            data.map((item, key) => {
                tabs.push(<li className="nav-item" key={item.groupName} onClick={()=>this.props.onTabChange(key)}>
                    <a data-toggle="tab" className={key == this.props.tabStep ? "nav-link active" : "nav-link"} href={`#${item.groupName}`} aria-controls={`${item.groupName}`} aria-selected="false" onClick={() => this.onTabClick(item.groupName)} id={`a_${key}`}>{item.groupName}</a>
                </li>)
            })
        }
        return tabs
    }
    addTabContents = (data, tab) => {
        let content = [];
        if (data.length > 0) {
            data.map((item, key) => {
                let datas = [['Task', 'Percentage']]
                if (item.groupName === tab) {
                    item.segments.map((segment, index) => {
                        datas.push([`${segment.name}`, segment.percent])
                        // {
                        //     item.percent.map((perc, i) => {
                        //         if (perc.id === segment.segmentId) {
                        //             datas.push([`${segment.name}`, perc.percent])
                        //         }
                        //     })
                        // }
                    })
                }
                if(!tab && key===this.props.tabStep){
                    item.segments.map((segment, index) => {
                        
                        datas.push([`${segment.name}`, segment.percent])
                        // {
                        //     item.percent.map((perc, i) => {
                        //         if (perc.id === segment.segmentId) {
                        //             datas.push([`${segment.name}`, perc.percent])
                        //         }
                        //     })
                        // }
                    })
                }

                if (item.groupName === tab) {
                    content.push(<div id={item.groupName} className='tab-pane fade tabContentdiv show active' role="tabpanel" key={key}>
                        <Chart
                            width={'100%'}
                            height={'400px'}
                            chartType="PieChart"
                            loader={<div>Loading Chart</div>}
                            data={datas}
                            options={{
                                is3D: true,
                                chartArea: {
                                    left: 0,
                                    top: 20,
                                    width: "100%",
                                    height: "100%"
                                },
                                legend: {
                                    position: "labeled"
                                }
                            }}
                            graph_id={`graph_${key}`}
                        />
                    </div>)
                }
                if (!tab) {
                    if (key === this.props.tabStep) {
                        content.push(<div id={item.groupName} className='tab-pane fade tabContentdiv show active' role="tabpanel" key={key}>
                            <Chart
                                width={'100%'}
                                height={'400px'}
                                chartType="PieChart"
                                loader={<div>Loading Chart</div>}
                                data={datas}
                                options={{
                                    is3D: true,
                                    chartArea: {
                                        left: 0,
                                        top: 20,
                                        width: "100%",
                                        height: "100%"
                                    },
                                    legend: {
                                        position: "labeled"
                                    }
                                }}
                                graph_id={`graph_${key}`}
                            />
                        </div>)
                    }
                }
                // )
            })
        }
        return content
    }
    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <ul className="nav nav-tabs ValidationTabs" role="tablist" id="myTab">
                        {this.props.tabs.length > 0 && this.addTabs(this.props.tabs)}
                    </ul>
                    <div className="tab-content ValidationTabcontent" id="myTabContent" >
                        {this.props.tabs.length > 0 && this.addTabContents(this.props.tabs, this.state.tab)}
                    </div>

                </div>
            </div>
        )
    }
}

export default (ResultTabs);



// WEBPACK FOOTER //
// ./src/components/Segmentation/Results/ResultsTabs/ResultsTabs.jsx